export default {
  getFeedbackComment: state => state.feedbackComment,
};
